/**
 * Sage Craft Box: paper-layering reveal.
 *
 * Two sheets of paper: the wildflower pop-up card art sits on top,
 * tucked over the sage panel underneath it. When the section scrolls
 * into view, the sage panel slides down and out from behind the
 * wildflower - a short, heavily-eased CSS transition (see
 * poplife-tokens.css.liquid's .pl-craft / .pl-craft.is-revealed
 * rules), not a scroll-length pin/hold. This script's only job is
 * adding that one class at the right moment; the motion itself is
 * plain CSS, so it always plays the same way regardless of how fast
 * or slow the user scrolls past it.
 *
 * Triggers once per page load and stays revealed - like a real
 * notecard, once pulled out from under the card, it doesn't tuck
 * itself back in if you scroll back up.
 */
(function () {
  var wrap = document.querySelector('.pl-reveal');
  var card = wrap && wrap.querySelector('.pl-craft');
  if (!wrap || !card) return;

  function reveal() {
    card.classList.add('is-revealed');
  }

  if (!('IntersectionObserver' in window)) {
    // No IntersectionObserver support - just show it revealed already,
    // no animation, rather than leaving it permanently tucked away.
    reveal();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal();
          observer.disconnect();
        }
      });
    },
    {
      // Fires once the section is meaningfully on screen, not the
      // instant its first pixel appears at the very bottom edge of
      // the viewport.
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  function init() {
    observer.observe(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
